module.exports = __webpack_public_path__ + "img/news-banner-bg.5f2c3c36.png";